import { Checkbox, Modal, ModalProps } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { HibraryRootState } from '../../../redux/rootReducer';

const MaintenanceModalStyled = styled(Modal)`
    .maintenance-image {
        width: 100%;
        height: auto;
    }

    .flex-container {
        display: flex;
        justify-content: center;
        padding: 0 1.25rem 1.25rem 1.25rem;
    }
`;

const MaintenanceModal = () => {
    const maintenancePopupClosed = localStorage.getItem('maintenancePopupClosed');
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [isChecked, setIsChecked] = useState<boolean>(false);

    const { authen } = useSelector(
        (state: HibraryRootState) => ({
            authen: state.auth
        }),
        shallowEqual
    );

    useEffect(() => {
        const shouldShowPopup = isShowMaintenancePopup() && !maintenancePopupClosed;
        const shouldResetStorage = maintenancePopupClosed && dayjs().isSameOrAfter(dayjs('2025-07-16 18:00'));

        if (shouldShowPopup) {
            setIsOpen(true);
        }

        if (shouldResetStorage) {
            localStorage.removeItem('maintenancePopupClosed');
        }
    }, []);

    const isShowMaintenancePopup = () => {
        const now = dayjs();
        const start = dayjs('2025-07-14 06:00');
        const end = dayjs('2025-07-16 13:00');
        return now.isSameOrAfter(start) && now.isBefore(end);
    };

    const modalConfig: ModalProps = {
        open: isOpen,
        onCancel: () => setIsOpen(false),
        footer: null,
        centered: true,
        width: 900,
        afterClose: () => {
            if (isChecked) localStorage.setItem('maintenancePopupClosed', 'true');
        }
    };

    return (
        <MaintenanceModalStyled {...modalConfig}>
            <img
                className='maintenance-image'
                src={
                    authen.isCuDomain
                        ? '/images/maintenance/maintenance-background-cu.png'
                        : '/images/maintenance/maintenance-background-hibrary.png'
                }
            />
            <div className='flex-container'>
                <Checkbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
                    ไม่ต้องแสดงอีก
                </Checkbox>
            </div>
        </MaintenanceModalStyled>
    );
};

export default MaintenanceModal;
